import { render, staticRenderFns } from "./StartHealthModal.vue?vue&type=template&id=de9f9c70"
import script from "./StartHealthModal.vue?vue&type=script&lang=js"
export * from "./StartHealthModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports